module.exports = __webpack_public_path__ + "static/aarakocra_cloud_castle-51f6b4bba82e3e882b13bc5bc577d584.png";